"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[8232],{

/***/ 8232:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ blogSlider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1732);



function blogSlider() {
  const settings = {
    blogSelector: '[data-blog-selector]',
    articleCards: '[data-article-tags]',
    slider: '[data-homepage-blog-slider]',
  }

  const swiperConfig = {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.js-blog-section-swiper-next',
      prevEl: '.js-blog-section-swiper-prev',
    },
    navigation: {
      nextEl: '.blog-slider-next',
      prevEl: '.blog-slider-prev',
    },
    pagination: {
      el: '.blog-slider-pagination',
      type: 'bullets',
      bulletActiveClass: 'on',
      bulletClass:
        'bullet block w-2.5 aspect-square rounded-full border border-solid border-galaxy bg-galaxy opacity-20 on:opacity-100',
    },
    breakpoints: {
      700: {
        slidesPerView: 2.8,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3.8,
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      slideRole: 'presentation',
    },
  }

  ;(function init() {
    initializeEventListeners()
    initializeSwiper()
    // hideInactiveBlogLinks()
  })()

  function initializeEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.blogSelector).on('click', changeActiveBlog)
  }

  function initializeSwiper() {
    const swiperEl = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slider)[0]
    if (swiperEl && !swiperEl.swiper) {
      new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(swiperEl, swiperConfig)
    }
  }

  async function changeActiveBlog() {
    const swiperEl = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slider)[0]
    let swiper = swiperEl.swiper
    const $activeSelector = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    const $notActiveSelectors = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.blogSelector).not($activeSelector)

    // Activate the clicked button
    $activeSelector.addClass('on').attr('aria-selected', true).attr('aria-controls', jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slider).attr('id'))

    // Deactivate all other buttons
    $notActiveSelectors.removeClass('on').attr('aria-selected', false).attr('aria-controls', '')

    // Get the active blog handle
    const activeHandle = $activeSelector.data('blog-selector')
    const activeName = activeHandle.replaceAll('-', ' ')

    try {
      // Create array of promises for pages 1-5
      const pagePromises = Array.from({ length: 5 }, (_, index) => {
        const page = index + 1
        const url = `/blogs/news/?sections=blog-ajax&page=${page}`
        return jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(url)
      })

      // Fetch all pages concurrently
      Promise.all(pagePromises).then((responses) => {
        // Collect all slides from all pages
        let $allSlides = jquery__WEBPACK_IMPORTED_MODULE_0___default()()

        responses.forEach((response) => {
          if (response && response['blog-ajax']) {
            const $blogAjax = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response['blog-ajax'])
            const $pageSlides = $blogAjax.find('.swiper-slide')
            $allSlides = $allSlides.add($pageSlides)
          }
        })

        // Filter slides based on active handle
        const $filteredSlides = $allSlides
          .filter((index, element) => {
            const $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element)
            const tags = $slide.data('article-tags') || []
            return tags.includes(activeHandle) || activeHandle === 'new'
          })
          .slice(0, 10)

        // Remove all existing slides
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiperEl).find('.swiper-slide').remove()
        // Add filtered slides to the wrapper
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiperEl).find('.swiper-wrapper').append($filteredSlides)
        const totalSlides = jquery__WEBPACK_IMPORTED_MODULE_0___default()(swiperEl).find('.swiper-slide').length
        const midPoint = Math.floor(totalSlides / 2)
        swiper.destroy()
        swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(swiperEl, swiperConfig)
        swiper.slideTo(midPoint)
      })
    } catch (e) {
      console.error({
        location: 'changeActiveBlog',
        error: e,
      })
    }
  }

  /* Hide blog links that are not in the article tags */
  function hideInactiveBlogLinks() {
    // get all article tags
    const allArticleTags = []

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.slider)
      .find(settings.articleCards)
      .each(function (index, element) {
        const articleTags = jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).data('article-tags')
        articleTags.forEach((tag) => {
          if (!allArticleTags.includes(tag)) {
            allArticleTags.push(tag)
          }
        })
      })

    // hide all blog links that are not in the article tags
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.blogSelector).each(function (index, element) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).data('blog-selector') === 'new') return

      if (!allArticleTags.includes(jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).data('blog-selector'))) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(element).hide()
      }
    })
  }
}


/***/ })

}]);